import React from 'react'
import Link from 'next/link'
import styles from './CtaBand.module.scss'

interface CtaBandProps {
  onContact?: () => void
}

const CtaBand = ({ onContact }: CtaBandProps) => {
  return (
    <section className={styles['cta-wrapper']}>
      <div className={styles['cta']}>
        <div className={styles['glow']} aria-hidden='true' />
        <div className={styles['content']}>
          <h2 className={styles['heading']}>Let&apos;s build what comes next</h2>
          <p className={styles['subtitle']}>
            Partner with the team behind a headless commerce platform built for
            speed, scale, and real merchant outcomes.
          </p>
          <div className={styles['actions']}>
            <button
              type='button'
              className={styles['primary']}
              onClick={onContact}
            >
              Get in touch
            </button>
            <Link href='/our-apps' className={styles['secondary']}>
              Explore our apps
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CtaBand
